const ActivityFilterStyles = {
  tableHeadingFilterImage: {
    img: {
      width: "30px",
      height: "24px",
    },
  },
  tableHeadingFilterText: {
    fontFamily: "Noto Sans",
    fontSize: "14px",
    fontWeight: "400",
    lineHeight: "24px",
    letterSpacing: "0px",
    textAlign: "left",
    marginTop: "-5px",
    textTransform: "none",
  },
  popoverContent: {
    width: "200px",
    height: "90px",
    padding: "20px 20px 0px 20px",
    gap: "20px",
    borderRadius: "4px",
  },
  popOver: {
    "& .MuiPopover-paper": {
      left: "unset !important",
      right: "0px !important",
      "@media (max-width: 1024px)": {
        right: "7px !important",
      },
    },
    "@media (max-width: 599px)": {
      "& .MuiPopover-paper": {
        left: "unset !important",
        right: "7px !important",
      },
    },
  },
};
export default ActivityFilterStyles;
